import CircledIcon from "./CircledIcon";

export default CircledIcon;
